export default __webpack_public_path__ + "static/media/user-icon.b262c4e5.svg";